/**
 * Unified Analytics Hub
 * =====================
 * Simplified analytics dashboard showing operational metrics.
 * Clean, compact design matching executor/supervisor dashboard.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { EMZI_COLORS } from '../styles/emziCI';

// Import analytics panel
import SystemAnalyticsPanel from '../components/analytics/SystemAnalyticsPanel';

const UnifiedAnalyticsHub = () => {
  const navigate = useNavigate();
  const { isAdmin, isManagement } = useAuth();

  // Check permissions
  React.useEffect(() => {
    if (!isAdmin() && !isManagement()) {
      navigate('/dashboard');
    }
  }, [isAdmin, isManagement, navigate]);

  return (
    <div className="min-h-screen" style={{ backgroundColor: EMZI_COLORS.surface }}>
      {/* Simple Header */}
      <div 
        className="sticky top-0 z-20 px-4 py-3 border-b" 
        style={{ 
          backgroundColor: EMZI_COLORS.primary,
          borderColor: EMZI_COLORS.border 
        }}
      >
        <h1 className="text-lg font-bold text-white flex items-center gap-2">
          📊 Analytics Hub
        </h1>
        <p className="text-xs text-white/80">
          Operational metrics & user activity
        </p>
      </div>

      {/* Analytics Content */}
      <div className="pb-20">
        <SystemAnalyticsPanel />
      </div>
    </div>
  );
};

export default UnifiedAnalyticsHub;
